// extracted by mini-css-extract-plugin
export default {"section":"Quote_section__X2o9e","quote":"Quote_quote__SiZ2P","left":"Quote_left__u1ZDN","right":"Quote_right__prxIJ"};